import { BigWin } from './BigWinsSection.types'

export const BigWins: BigWin[] = [
  {
    imgSrc: 'landingPage.bigWinGame1',
    name: 'Fire Stampede',
    prize: '$400,800.00',
    city: 'Kitchener, ON',
    date: '24 May 2025',
  },
  {
    imgSrc: 'landingPage.bigWinGame2',
    name: 'Gold Blitz Extreme ™',
    prize: '$217,512.00',
    city: 'Orangeville, ON',
    date: '13 June 2024',
  },
  {
    imgSrc: 'landingPage.bigWinGame3',
    name: 'Sweet Bonanza 1000',
    prize: '$215,559.75',
    city: 'Burlington, ON',
    date: '22 May 2025',
  },
  {
    imgSrc: 'landingPage.bigWinGame4',
    name: 'Reign of Rome',
    prize: '$180,750.00',
    city: 'Windham Centre, ON',
    date: '25 April 2025',
  },
  {
    imgSrc: 'landingPage.bigWinGame5',
    name: 'Out of The Ice',
    prize: '$180,000.00',
    city: 'North York, ON',
    date: '27 March 2024',
  },
]
